import React from "react";

export default function BillingCancel() {
  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginTop: 0 }}>Billing Cancelled</h1>
      <div style={{ color: "#9fb0c3" }}>
        Your checkout was cancelled. No changes were made.
      </div>
    </div>
  );
}
